import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import BusinessTripHead from '@/types/table/businessTripHead';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ConsoleControllerDate extends BusinessTripHead {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ConsoleController extends BaseController {

  static getUserLoginList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/console/getUserLoginList', params, httpOptions);
  }
  static listWorkOrderFlowBusinessTrip(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/businessTripHead/listWorkOrder/flowBusinessTrip', params, httpOptions);
  }

  static listWorkOrderFlowMeetingRequest(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/console/listWorkOrder', params, httpOptions);
  }

  static weeklyScheduleList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/console/weeklyScheduleList', params, httpOptions);
  }

  static roleLeaders(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/console/roleLeaders', params, httpOptions);
  }

  static listNoticeMessageList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/console/listNoticeMessageList', params, httpOptions);
  }
  static listMeetingList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/console/listMeetingList', params, httpOptions);
  }

  static createNewTaskList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/console/createNewTaskList', params, httpOptions);
  }

}
